import { PropsWithChildren } from 'react';
import { createSlot } from '@radix-ui/react-slot';

import css from './styles.module.css';

const IconSlot = createSlot('Header.Icon');

/** A decorative icon, rendered before the title. */
export function HeaderIcon({ children }: PropsWithChildren) {
  return (
    <IconSlot aria-hidden className={css.icon}>
      {children}
    </IconSlot>
  );
}
